import { Stack } from "@mui/material";
import { ITagProps, Tag } from "./Tag";
import { useStyle } from "./style";
import { useDeviceType } from "@hook/useDeviceType";

interface IParams {
    tags: ITagProps[];
}

export const TagList = (props: IParams) => {
    const { tags } = props;
    const { isMobile } = useDeviceType();
    const { classes } = useStyle({});

    return (
        <Stack
            alignItems={{ xs: "center", sm: "end" }}
            className={`${isMobile ? "" : classes.chipDesktop}`}
            spacing={1}
        >
            {tags.map(({ label, variant }) => (
                <Tag key={`${label}_${variant}`} label={label} variant={variant} />
            ))}
        </Stack>
    );
};
